import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Team: BleskIcon = forwardRef(function Team(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <circle
        cx="16.0018"
        cy="11.5058"
        r="2.00083"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.99658"
        y="2.99622"
        width="18.0075"
        height="18.0075"
        rx="4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="8.99909"
        cy="11.0056"
        r="2.50104"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5013 21.0038V20.0034C14.5013 18.0695 12.9336 16.5019 10.9998 16.5019H7.05315C5.43346 16.5043 4.02769 17.6194 3.65674 19.196"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.002 16.5079H17.5086C18.8825 16.5117 20.1248 17.3256 20.6769 18.5837"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
